<div class="input-fields">
    <div class="label">
        <span>{{ label }}:</span>
    </div>
    <div class="input-field">
        <input matInput type="number" min="0" max="255" [(ngModel)]="valuePart1" (keypress)="keypress($event)" (keyup)="keyup($event)">
    </div>
    <div class="dot">.</div>
    <div class="input-field">
        <input matInput type="number" [(ngModel)]="valuePart2" (keypress)="keypress($event)" (keyup)="keyup($event)">
    </div>
    <div class="dot">.</div>
    <div class="input-field">
        <input matInput type="number" [(ngModel)]="valuePart3" (keypress)="keypress($event)" (keyup)="keyup($event)">
    </div>
    <div class="dot">.</div>
    <div class="input-field">
        <input matInput type="number" [(ngModel)]="valuePart4" (keypress)="keypress($event)" (keyup)="keyup($event)">
    </div>
</div>